export default (locale) => [
  {
    path: `/${locale}/livechat`,
    name: 'livechat',
    component: () => import('pages/LivechatPage.vue'),
  },
]
